// Copyright ©️ 2026 eVolve MEP, LLC

/** Given two numbers, returns true if they are almost exactly equal
 * @param a the first number to compare
 * @param b the second number to compare
 * @param [precision=1e-4] The smallest absolute difference to allow.
 * */
export const isAlmostExactlyEqual = (a: number, b: number, precision: number = 1e-4) => Math.abs(a - b) <= precision;
